import { Job } from '../types';

export const generateMockJobs = (): Job[] => [
  {
    id: '1',
    title: 'Senior Housemaid',
    company: 'Al-Sabah Family',
    location: 'Kuwait City, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 300,
      max: 400,
      currency: 'KWD'
    },
    requirements: [
      'Minimum 3 years experience in household management',
      'Fluent in Arabic and basic English',
      'Knowledge of cleaning products and techniques',
      'Ability to cook traditional Middle Eastern dishes',
      'Valid health certificate',
      'Clean background check'
    ],
    description: 'We are seeking a dedicated and experienced housemaid to join our family household. The ideal candidate will be responsible for maintaining a clean and organized home environment, preparing meals, and providing exceptional household support.',
    benefits: [
      'Competitive salary package',
      'Private accommodation provided',
      'Health insurance coverage',
      'Annual vacation allowance',
      'Professional development opportunities'
    ],
    postedDate: '2024-01-10',
    status: 'Active'
  },
  {
    id: '2',
    title: 'Experienced Barista',
    company: 'Coffee Corner Kuwait',
    location: 'Salmiya, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 250,
      max: 320,
      currency: 'KWD'
    },
    requirements: [
      'Minimum 2 years barista experience',
      'Knowledge of specialty coffee preparation',
      'Customer service skills',
      'Basic English communication',
      'Flexibility with working hours',
      'Food safety certification preferred'
    ],
    description: 'Join our dynamic coffee shop team as an experienced barista. You will be responsible for preparing high-quality coffee beverages, providing excellent customer service, and maintaining a clean workspace.',
    benefits: [
      'Competitive hourly wage',
      'Tips and commission',
      'Staff meal allowance',
      'Training opportunities',
      'Flexible scheduling'
    ],
    postedDate: '2024-01-12',
    status: 'Active'
  },
  {
    id: '3',
    title: 'Heavy Truck Driver',
    company: 'Kuwait Transport Co.',
    location: 'Ahmadi, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 400,
      max: 550,
      currency: 'KWD'
    },
    requirements: [
      'Valid heavy vehicle driving license',
      'Minimum 5 years truck driving experience',
      'Clean driving record',
      'Knowledge of Kuwait roads and regulations',
      'Physical fitness for long-distance driving',
      'Basic mechanical knowledge preferred'
    ],
    description: 'We are looking for experienced heavy truck drivers to join our transportation fleet. Drivers will be responsible for safely transporting goods across Kuwait and neighboring regions.',
    benefits: [
      'Competitive salary based on experience',
      'Overtime compensation',
      'Company vehicle provided',
      'Health and life insurance',
      'Annual performance bonus'
    ],
    postedDate: '2024-01-08',
    status: 'Active'
  },
  {
    id: '4',
    title: 'Construction Worker',
    company: 'Gulf Construction Ltd.',
    location: 'Kuwait City, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 280,
      max: 380,
      currency: 'KWD'
    },
    requirements: [
      'Previous construction experience',
      'Physical strength and stamina',
      'Basic safety training',
      'Ability to work in team environment',
      'Willingness to work outdoors',
      'Valid work permit'
    ],
    description: 'Join our construction team working on residential and commercial projects across Kuwait. Workers will be involved in various construction activities including concrete work, masonry, and general labor.',
    benefits: [
      'Competitive daily wages',
      'Safety equipment provided',
      'Transportation to work sites',
      'Medical insurance',
      'Skills development training'
    ],
    postedDate: '2024-01-15',
    status: 'Active'
  },
  {
    id: '5',
    title: 'Security Guard',
    company: 'SecureKuwait Services',
    location: 'Various Locations, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 280,
      max: 350,
      currency: 'KWD'
    },
    requirements: [
      'High school education or equivalent',
      'Previous security experience preferred',
      'Clean background check',
      'Good physical condition',
      'Basic English communication',
      'Willingness to work night shifts'
    ],
    description: 'We are seeking reliable security guards to protect commercial and residential properties. Guards will monitor premises, control access, and ensure the safety of people and property.',
    benefits: [
      'Stable monthly salary',
      'Uniform and equipment provided',
      'Health insurance',
      'Professional security training',
      'Career advancement opportunities'
    ],
    postedDate: '2024-01-05',
    status: 'Active'
  },
  {
    id: '6',
    title: 'Restaurant Waitress',
    company: 'Marina Bay Restaurant',
    location: 'Marina Mall, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 220,
      max: 300,
      currency: 'KWD'
    },
    requirements: [
      'Previous restaurant service experience',
      'Excellent customer service skills',
      'Professional appearance',
      'Ability to work under pressure',
      'Basic English and Arabic',
      'Flexibility with work schedules'
    ],
    description: 'Join our upscale restaurant team as a waitress. You will provide exceptional dining service to our guests, take orders, serve food and beverages, and ensure customer satisfaction.',
    benefits: [
      'Base salary plus tips',
      'Staff meals provided',
      'Training provided',
      'Service charge distribution',
      'Career growth opportunities'
    ],
    postedDate: '2024-01-11',
    status: 'Active'
  },
  {
    id: '7',
    title: 'Commercial Cleaner',
    company: 'CleanPro Kuwait',
    location: 'Kuwait City, Kuwait',
    type: 'Part-time',
    salaryRange: {
      min: 180,
      max: 250,
      currency: 'KWD'
    },
    requirements: [
      'Previous cleaning experience',
      'Attention to detail',
      'Physical stamina',
      'Reliability and punctuality',
      'Basic safety knowledge',
      'Own transportation preferred'
    ],
    description: 'We need dedicated cleaners for commercial office buildings. Work involves general cleaning, sanitizing, and maintaining clean work environments for our corporate clients.',
    benefits: [
      'Flexible working hours',
      'Weekly payment',
      'Cleaning supplies provided',
      'Performance bonuses',
      'Additional hours available'
    ],
    postedDate: '2024-01-14',
    status: 'Active'
  },
  {
    id: '8',
    title: 'Registered Nurse - ICU',
    company: 'Kuwait Medical Center',
    location: 'Hawalli, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 550,
      max: 750,
      currency: 'KWD'
    },
    requirements: [
      'Valid nursing license',
      'Minimum 3 years ICU experience',
      'BLS and ACLS certification',
      'English proficiency',
      'Strong clinical skills',
      'Ability to work 12-hour shifts'
    ],
    description: 'We are seeking experienced ICU nurses to join our critical care team. Nurses will provide direct patient care, monitor vital signs, administer medications, and work collaboratively with healthcare teams.',
    benefits: [
      'Excellent salary package',
      'Health and dental insurance',
      'Continuing education support',
      'Annual leave allowance',
      'Professional development opportunities',
      'Shift differentials'
    ],
    postedDate: '2024-01-09',
    status: 'Active'
  },
  {
    id: '9',
    title: 'English Teacher',
    company: 'International School Kuwait',
    location: 'Salwa, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 700,
      max: 1000,
      currency: 'KWD'
    },
    requirements: [
      "Bachelor's degree in English or Education",
      'Teaching certification/TESOL',
      'Minimum 3 years teaching experience',
      'Native or near-native English proficiency',
      'Classroom management skills',
      'International curriculum experience preferred'
    ],
    description: 'We are looking for qualified English teachers to join our international school. Teachers will develop lesson plans, deliver engaging instruction, assess student progress, and participate in school activities.',
    benefits: [
      'Competitive tax-free salary',
      'Housing allowance',
      'Health insurance for family',
      'Annual flight allowance',
      'Professional development budget',
      'Summer vacation paid'
    ],
    postedDate: '2024-01-06',
    status: 'Active'
  },
  {
    id: '10',
    title: 'Personal Driver (Female)',
    company: 'Elite Chauffeur Services',
    location: 'Kuwait City, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 350,
      max: 450,
      currency: 'KWD'
    },
    requirements: [
      'Valid Kuwait driving license',
      'Minimum 5 years driving experience',
      'Clean driving record',
      'Professional appearance',
      'Discretion and confidentiality',
      'Flexibility with working hours'
    ],
    description: 'We are seeking a professional female driver to provide transportation services for VIP female clients. Driver will ensure safe, comfortable, and timely transportation while maintaining the highest level of professionalism.',
    benefits: [
      'Attractive salary package',
      'Company vehicle for personal use',
      'Fuel allowance',
      'Health insurance',
      'Performance bonuses',
      'Paid vacation'
    ],
    postedDate: '2024-01-07',
    status: 'Closed'
  },
  {
    id: '11',
    title: 'Chef Assistant',
    company: 'Royal Kuwait Hotel',
    location: 'Kuwait City, Kuwait',
    type: 'Full-time',
    salaryRange: {
      min: 300,
      max: 400,
      currency: 'KWD'
    },
    requirements: [
      'Culinary education or equivalent experience',
      'Knowledge of Middle Eastern cuisine',
      'Food safety certification',
      'Ability to work in fast-paced environment',
      'Team collaboration skills',
      'Willingness to work varied shifts'
    ],
    description: 'Join our award-winning kitchen team as a chef assistant. You will support head chefs in food preparation, maintain kitchen cleanliness, and help create memorable dining experiences for our hotel guests.',
    benefits: [
      'Competitive salary',
      'Staff accommodation available',
      'Meals provided during shifts',
      'Training under experienced chefs',
      'Career advancement opportunities',
      'Health insurance'
    ],
    postedDate: '2024-01-13',
    status: 'Draft'
  },
  {
    id: '12',
    title: 'Office Cleaner',
    company: 'Corporate Clean Kuwait',
    location: 'Sharq, Kuwait',
    type: 'Part-time',
    salaryRange: {
      min: 160,
      max: 220,
      currency: 'KWD'
    },
    requirements: [
      'Previous office cleaning experience',
      'Attention to detail',
      'Trustworthy and reliable',
      'Basic English communication',
      'Flexible working hours',
      'Health certificate required'
    ],
    description: 'We need reliable office cleaners for corporate buildings in Sharq business district. Work involves daily cleaning of offices, restrooms, common areas, and maintaining professional work environments.',
    benefits: [
      'Flexible part-time hours',
      'Weekly payment system',
      'All cleaning supplies provided',
      'Performance-based bonuses',
      'Opportunity for additional hours'
    ],
    postedDate: '2024-01-04',
    status: 'Closed'
  }
];

export const JOB_STATUS_COLORS = {
  'Active': {
    bg: 'bg-green-100',
    text: 'text-green-800',
    border: 'border-green-200'
  },
  'Closed': {
    bg: 'bg-red-100',
    text: 'text-red-800',
    border: 'border-red-200'
  },
  'Draft': {
    bg: 'bg-gray-100',
    text: 'text-gray-800',
    border: 'border-gray-200'
  }
};

export const JOB_TYPE_COLORS = {
  'Full-time': {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    border: 'border-blue-200'
  },
  'Part-time': {
    bg: 'bg-purple-100',
    text: 'text-purple-800',
    border: 'border-purple-200'
  },
  'Contract': {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    border: 'border-orange-200'
  },
  'Temporary': {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    border: 'border-yellow-200'
  }
};